import type { ReactElement } from 'react';
import { useAuthStore } from '@/entities/user';
import { EyebrowLabel } from '@/shared/ui';
import { QuoteGuestPrompt } from './quote-guest-prompt';
import { QuoteRecentDesigns } from './quote-recent-designs';

interface QuoteDesignPickerProps {
  /** 섹션 id — 첫 화면의 "내 디자인으로 요청" 버튼이 여기로 내려온다. */
  readonly id: string;
}

/**
 * "내 디자인으로 견적 요청" — 로그인하면 최근 저장한 디자인과 견적 요청 버튼을, 아니면 로그인 안내를 보여 준다.
 * 내 디자인 목록(designs.list)은 로그인한 경우에만 읽는다 — 비로그인 요청은 서버가 거절하기 때문이다.
 */
export const QuoteDesignPicker = ({ id }: QuoteDesignPickerProps): ReactElement => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  return (
    <section
      id={id}
      aria-labelledby="quote-designs-heading"
      className="flex scroll-mt-28 flex-col gap-8 sm:gap-10"
    >
      <header className="flex flex-col gap-4 border-t border-foreground pt-6">
        <EyebrowLabel accent>My designs</EyebrowLabel>
        <h2
          id="quote-designs-heading"
          className="text-[clamp(1.5rem,2.6vw,2.25rem)] leading-[1.2] font-bold tracking-[-0.03em]"
        >
          내 디자인으로 견적 요청
        </h2>
        <p className="text-[15px] text-muted-foreground sm:text-base">
          저장한 디자인을 골라 수량과 요청사항을 적으면 견적 요청이 끝나요.
        </p>
      </header>

      {isAuthenticated ? <QuoteRecentDesigns /> : <QuoteGuestPrompt />}
    </section>
  );
};
